export const SOURCE_CHOWNOW_ALLOWED_PATHS = ['/menu/management'];
export const SOURCE_CHOWNOW = 'chownow';
